import React from 'react';
import PropTypes from 'prop-types';
import HrbTranslate from '../../language/HrbTranslate';
import EmdashText from './EmdashText';

const ProvinceText = ({ province }) => {
    return ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']
        .includes((province || '').toUpperCase()) ? (
        <HrbTranslate text={`Account.Provinces.${province.toUpperCase()}`} />
    ) : (
        <EmdashText />
    )
};

ProvinceText.propTypes = {
    province: PropTypes.string
}

export default ProvinceText;